// Filtro para limpiar espacios al principio y final
// Tambien convierte multiples espacios en uno solo
export default string => {
  if (typeof string === 'string') return string.trim().replace(/ +(?= )/g, '')

  return string
}
